import './global.css'
import { createRoot } from 'react-dom/client'
import './index.css'
import { ContainerProvider } from './core/lifecycle/ContainerProvider.tsx'
import { CssBaseline } from '@mui/material'
import { RouterProvider } from 'react-router-dom'
import { appRouter } from './app-router.tsx'
import App from './core/app-shell/App.tsx'
import { ModalProvider } from '@/core/modal/ModalProvider.tsx'
import { AppThemeProvider } from '@/core/app-shell/AppThemeProvider.tsx'
import { StrictMode } from 'react'
import { appContainer } from '@/app-init'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ContainerProvider container={appContainer}>
      <AppThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CssBaseline />
          <ModalProvider>
            <RouterProvider router={appRouter}></RouterProvider>
          </ModalProvider>
        </LocalizationProvider>
      </AppThemeProvider>
    </ContainerProvider>
  </StrictMode>,
)
